/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import Cookie from 'js-cookie'
import { CSRF_TOKEN } from './constants.mjs'

/**
 * Returns the CSRF token.
 * @return {*}
 */
export function getCSRFToken () {
  return Cookie.get(CSRF_TOKEN)
}
